import React, { Component, CSSProperties } from 'react';
import 'styled-components/macro';
import * as types from 'styled-components/cssprop'; /* eslint-disable-line */
import { RootDispatch, RootState } from '../../models/configure_store';
import { css, withTheme } from 'styled-components';
import { connect } from 'react-redux';
import { isRTL } from '@/utils/utils';
import { isMobile } from '@/utils/constants';
import VoiceIcon from './voice_icon';
import SuccessIcon from './success_icon';
import LoadingIcon from './loading_icon';
import MistakeIcon from './mistake_icon';
import CloseButton from '../close-btn';
import { VerifyVoiceWrap } from './style';
import { Context } from '../../i18n';

const mapState = ({ captcha }: RootState) => {
  const {
    question_url,
    voice_loading_load,
    voice_loading_verify,
    verify_result_msg,
    isTooFrequently,
    voice_status,
    backup_url1,
    backup_url1Index,
  } = captcha;
  return {
    question_url,
    voice_loading_load,
    voice_loading_verify,
    verify_result_msg,
    isTooFrequently,
    voice_status,
    backup_url1,
    backup_url1Index,
  };
};
const mapDispatch = ({ captcha }: RootDispatch) => {
  return {
    // refresh4Voice: captcha.refresh4Voice,
    update: captcha.update,
  };
};
type VerifyVoiceProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch> & {
    sliding: boolean;
    onMouseMove: () => void;
    img_error_text: string;
    lang: string;
    show: boolean;
    theme: any;
    hideCloseBtn?: boolean;
    handleClose: (e: React.MouseEvent<HTMLElement>) => void;
    handleSubmit4Voice: (answer: any) => void;
    refresh: () => void;
  };
class VerifyVoice extends Component<VerifyVoiceProps> {
  state = {
    code: '',
    imgUrlError: false,
    playStatus: 'notStart', // 'notStart' | 'playing' | 'end'
  };
  myAudio: React.RefObject<HTMLAudioElement>;
  myInput: React.RefObject<HTMLInputElement>;
  myNotNormalBtn1: React.RefObject<HTMLDivElement>;
  myNotNormalText: React.RefObject<HTMLSpanElement>;
  static contextType = Context;
  context!: React.ContextType<typeof Context>;
  constructor(props: Readonly<VerifyVoiceProps>) {
    super(props);
    this.myAudio = React.createRef();
    this.myInput = React.createRef();
    this.myNotNormalBtn1 = React.createRef();
    this.myNotNormalText = React.createRef();
  }
  playAudio = () => {
    if (isMobile) {
      // 移动端开启无障碍模式，直接 focus 会导致，辅助读的内容过多和音频播放同时进行
      setTimeout(() => {
        this.myAudio.current?.play();
      }, 1000);
    } else {
      this.myAudio.current?.play();
    }
  };
  handlerInputChange = (e: any) => {
    e.persist();
    // if (Number.isNaN(e.target.valueAsNumber)) return;
    let _code = e.target.value || '';
    _code = _code.substr(0, 3);
    this.setState({
      code: _code,
    });
  };
  handlerAudioOnPlay = () => {
    this.setState({
      playStatus: 'playing',
    });
  };
  handlerCanplay = () => {
    const { update } = this.props;
    update({
      voice_loading_load: false,
      voice_status: 'normal',
    });
    // if (this.state.playStatus !== 'playing') {
    //   this.playAudio();
    // }
  };
  handlerAudioError = () => {
    const { update, question_url, backup_url1, backup_url1Index } = this.props;
    if (!question_url) return;
    if (backup_url1Index >= 0) {
      update({
        question_url: backup_url1[backup_url1Index],
        backup_url1Index: backup_url1Index - 1,
      });
    } else {
      update({
        voice_loading_load: false,
        voice_status: 'load_error',
      });
    }
  };
  handlerAudioEnded = () => {
    this.setState({
      playStatus: 'end',
    });
    // 这句是为了处理 ios 上 focus 无效的问题
    this.myInput.current?.focus();
    // 这句是为了处理 web focus 无效的问题
    setTimeout(() => {
      this.myInput.current?.focus();
    }, 0);
  };
  handlerSubmit = () => {
    const canSubmit = this.state.playStatus === 'end' && this.state.code;
    if (canSubmit) this.props.handleSubmit4Voice(this.state.code);
  };
  handlerListenAgain = () => {
    this.props.update({
      voice_status: 'normal',
    });
    this.playAudio();
    this.setState({
      playStatus: 'notStart',
      code: '',
    });
    setTimeout(() => {
      this.myInput.current?.focus();
    }, 0);
  };
  handlerRefresh = () => {
    // refresh4Voice
    this.props.refresh();
    this.setState({
      playStatus: 'notStart',
      code: '',
    });
  };
  handlerEnterDown = (e: any, actionName: string) => {
    e.persist();
    if (e.keyCode === 13) {
      switch (actionName) {
        case 'playAudio':
          this.playAudio();
          break;
        case 'submit':
          this.handlerSubmit();
          break;
        case 'refresh':
          this.handlerRefresh();
          break;
        case 'listenAgain':
          this.handlerListenAgain();
          break;
        case 'close':
          this.props.handleClose(e);
          break;
      }
    }
  };
  render() {
    const {
      hideCloseBtn,
      handleClose,
      question_url,
      voice_loading_load,
      voice_loading_verify,
      lang,
      theme,
      voice_status,
    } = this.props;
    const { voice_text } = this.context;
    let status_icon;
    let status_text;
    let status_btn_control: {
      btnCount: number;
      btn1?: Obj;
      btn2?: Obj;
    } = { btnCount: 0 };
    // const voice_status: string = 'verify_fail';
    const canSubmit = this.state.playStatus === 'end' && this.state.code;
    switch (voice_status) {
      case 'normal':
        break;
      case 'verify_succeed':
        status_text = voice_text.verify_succeed; // 验证成功
        status_icon = <SuccessIcon theme={theme}></SuccessIcon>;
        status_btn_control = {
          btnCount: 0,
        };
        break;
      case 'verify_fail':
        status_text = voice_text.verify_fail; // 验证失败
        status_icon = <MistakeIcon theme={theme}></MistakeIcon>;
        status_btn_control = {
          btnCount: 2,
          btn1: {
            name: voice_text.relisten_btn, // 重听
            actionName: 'listenAgain',
            fn: this.handlerListenAgain,
          },
          btn2: {
            name: voice_text.change_one_btn, // 换一个
            actionName: 'refresh',
            fn: this.handlerRefresh,
          },
        };
        break;
      case 'load_error':
        status_text = voice_text.load_error; // 验证码加载错误
        status_icon = <MistakeIcon theme={theme}></MistakeIcon>;
        status_btn_control = {
          btnCount: 1,
          btn1: {
            name: voice_text.reload_btn, // 重新加载
            actionName: 'refresh',
            fn: this.handlerRefresh,
          },
        };
        break;
      case 'play_error': // 目前没有这种情况
        status_text = voice_text.paly_error; // 验证码播放失败
        status_icon = <MistakeIcon theme={theme}></MistakeIcon>;
        status_btn_control = {
          btnCount: 2,
          btn1: {
            name: voice_text.replay_btn, // 重新播放
            actionName: 'refresh',
            fn: this.handlerListenAgain,
          },
          btn2: {
            name: voice_text.change_one_btn, // 换一个
            actionName: 'refresh',
            fn: this.handlerRefresh,
          },
        };
        break;
      case 'network_error':
        status_text = voice_text.network_error; // 网络错误，验证失败
        status_icon = <MistakeIcon theme={theme}></MistakeIcon>;
        status_btn_control = {
          btnCount: 1,
          btn1: {
            name: voice_text.retry_btn, // 重试
            actionName: 'refresh',
            fn: this.handlerRefresh,
          },
        };
        break;
      case 'verify_frequently':
        status_text = voice_text.verify_frequently; // 尝试次数过多，请5分钟后再试
        status_icon = <MistakeIcon theme={theme}></MistakeIcon>;
        status_btn_control = {
          btnCount: 1,
          btn1: {
            name: isMobile ? voice_text.close_btn : voice_text.got_it_btn,
            actionName: 'close',
            fn: handleClose,
          },
        };
        break;
      case 'verify_overtime':
        status_text = voice_text.verify_overtime; // 验证超时，请重新验证
        status_icon = <MistakeIcon theme={theme}></MistakeIcon>;
        status_btn_control = {
          btnCount: 1,
          btn1: {
            name: voice_text.reload_btn, // 重新加载
            actionName: 'refresh',
            fn: this.handlerRefresh,
          },
        };
        break;
    }
    const loading = voice_loading_load || voice_loading_verify;
    if (loading) {
      status_text = voice_text.loading_verify; // 正在验证中...
      if (voice_loading_load) status_text = voice_text.loading_load; // 加载中...
      status_icon = <LoadingIcon theme={theme}></LoadingIcon>;
      status_btn_control = {
        btnCount: 0,
      };
    }
    if (voice_status !== 'normal' && !loading) {
      this.myNotNormalText.current?.focus();
      setTimeout(() => {
        this.myNotNormalText.current?.focus();
      }, 0);
    }
    return (
      <VerifyVoiceWrap
        className={
          isMobile ? 'captcha_verify_voice-mobile' : 'captcha_verify-voice-web'
        }
        theme={theme}
        aria-atomic={true}
        aria-modal={true}
      >
        <CloseButton
          isRTL={isRTL(lang)}
          onClick={handleClose}
          hideCloseBtn={hideCloseBtn}
          isVoice={true}
        />
        <div
          aria-hidden={
            isMobile && (voice_status !== 'normal' || loading) && 'true'
          }
          tabIndex={
            (isMobile && (voice_status !== 'normal' || loading) && 0) ||
            undefined
          }
          style={
            isMobile
              ? ({
                  visibility: `${
                    voice_status === 'normal' && !loading ? 'visible' : 'hidden'
                  }`,
                } as CSSProperties)
              : {
                  display: `${
                    voice_status === 'normal' && !loading ? 'block' : 'none'
                  }`,
                }
          }
        >
          {/* 头部 */}
          <div className="captcha_verify_voice_bar" role="heading">
            <div className="captcha_verify_voice_bar--title_wrap">
              <div className="captcha_verify_voice_bar--title" tabIndex={1}>
                {/* 点击播放按钮，输入正确答案 */}
                {voice_text.title}
              </div>
            </div>
          </div>
          {/* 点击播放块 */}
          <div
            tabIndex={1}
            role="button"
            className="captcha_verify_voice_click_block"
            onClick={this.playAudio}
            onKeyDown={(e) => {
              return this.handlerEnterDown(e, 'playAudio');
            }}
          >
            {/* 声音 icon */}
            <VoiceIcon
              height={`0.22em`}
              width={`0.22em`}
              voiceIconColor={theme.voiceIconColor}
              voiceIconBgColor={theme.voiceBgIconColor}
              voiceIconUrl={theme.voiceIconUrl}
            ></VoiceIcon>

            {/* 点击播放文字 */}
            <div className="captcha_verify_voice_click_block--text_wrap">
              <div
                id="label-play"
                className="captcha_verify_voice_click_block--text"
              >
                {/* 点击播放 */}
                {voice_text.play_block_prompt}
              </div>
            </div>
          </div>
          <audio
            preload="load"
            aria-hidden="true"
            ref={this.myAudio}
            onLoadedMetadata={this.handlerCanplay}
            onPlay={this.handlerAudioOnPlay}
            onError={this.handlerAudioError}
            onEnded={this.handlerAudioEnded}
            // controls
            // src="http://video-boe.byted.org/storage/v1/tos-boe-v-70b29c/27aaaba3d2884334bb0f8477e4a55fa5?x-tos-algorithm=v2&x-tos-authkey=5bf25627da095a5cba28ace592de46cc&x-tos-expires=1621912100&x-tos-signature=ST0sxmZgrm6luHy5JSoZl-xXGWg"
            src={question_url || ''}
          >
            Your browser does not support the
            <code>audio</code> element.
          </audio>
          {/* 输入区域 */}
          <div className="captcha_verify_voice_input_wrap">
            <input
              tabIndex={1}
              className="captcha_verify_voice_input"
              ref={this.myInput}
              placeholder={voice_text.input_placeholder}
              // type="text"
              // pattern="[0-9a-zA-Z]*"
              // maxLength={5}
              type="number"
              autoComplete={'false'}
              onChange={this.handlerInputChange}
              value={this.state.code}
              onKeyDown={(e) => {
                return this.handlerEnterDown(e, 'submit');
              }}
            />
          </div>
          {/* footer */}
          <div className="captcha_verify_voice_footer--normal">
            <div
              // tabIndex={1}
              tabIndex={
                isMobile ? (voice_status === 'normal' ? 1 : undefined) : 1
              }
              role="button"
              className="captcha_verify_voice_footer--normal_btn1 captcha_verify_voice_footer_btn"
              style={{ opacity: canSubmit ? 1 : 0.5 }}
              onClick={this.handlerSubmit}
              onKeyDown={(e) => {
                return this.handlerEnterDown(e, 'submit');
              }}
            >
              {/* 验证 */}
              {voice_text.verify_btn}
            </div>
            <div
              // tabIndex={1}
              tabIndex={
                isMobile ? (voice_status === 'normal' ? 1 : undefined) : 1
              }
              role="button"
              className="captcha_verify_voice_footer--normal_btn2 captcha_verify_voice_footer_btn"
              onClick={this.handlerRefresh}
              onKeyDown={(e) => {
                return this.handlerEnterDown(e, 'refresh');
              }}
            >
              {/* 换一个 */}
              {voice_text.change_one_btn}
            </div>
          </div>
        </div>
        {/* 特殊状态 验证成功、验证失败、频繁验证、loading 等 */}
        {(voice_status !== 'normal' || loading) && (
          <div className="captcha_verify_voice_footer--not_normal_wrap">
            <div
              className="captcha_verify_voice_footer--not_normal_content_wrap"
              css={`
                padding-bottom: ${!isMobile && status_btn_control.btnCount === 0
                  ? '36px'
                  : 0};
              `}
            >
              {status_icon}
              <span tabIndex={1} ref={this.myNotNormalText}>
                {status_text}
              </span>
            </div>

            {status_btn_control.btnCount !== 0 && (
              <div className="captcha_verify_voice_footer--not_normal_btn_wrap">
                <div
                  tabIndex={1}
                  ref={this.myNotNormalBtn1}
                  role="button"
                  className="captcha_verify_voice_footer--not_normal_btn1 captcha_verify_voice_footer_btn"
                  onClick={status_btn_control.btn1?.fn}
                  onKeyDown={(e) => {
                    return this.handlerEnterDown(
                      e,
                      status_btn_control.btn1?.actionName
                    );
                  }}
                >
                  {status_btn_control.btn1?.name}
                </div>
                {status_btn_control.btnCount === 2 && (
                  <div
                    tabIndex={1}
                    role="button"
                    className="captcha_verify_voice_footer--not_normal_btn2 captcha_verify_voice_footer_btn"
                    onClick={status_btn_control.btn2?.fn}
                    onKeyDown={(e) => {
                      return this.handlerEnterDown(
                        e,
                        status_btn_control.btn2?.actionName
                      );
                    }}
                  >
                    {status_btn_control.btn2?.name}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </VerifyVoiceWrap>
    );
  }
}
export default withTheme(
  connect(mapState, mapDispatch as any)(VerifyVoice) as any
);
